















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Event } from '../../events/store/models';
import EventListItem from './EventListItem.vue';

@Component({
  components: {
    EventListItem,
  },
})
export default class EventList extends Vue {

  @Prop() private events!: Event[];

}
